import service from '@/services/SIRsic_vfc_otp';

export default {
  namespaced: true,

  state: {
    status: '',
  },

  mutations: {
    SET_STATUS(state, value) {
      state.status = value;
    },
  },

  actions: {
    async verify({ commit }, { otpCode, phone, ip }) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRsic_vfc_otp: {
            eesic_otp: [
              {
                otp_cel: `57${phone}`,
                otp_ip: ip,
                otp: otpCode,
              },
            ],
          },
        };

        service
          .post(payload)
          .then((response) => {
            const data = response.data?.dsSIRsic_vfc_otp;

            if (data?.eeEstados?.[0]?.Returnid === 0) {
              commit('SET_STATUS', 'ok');
              resolve(data);
            } else {
              const notification = {
                code: data?.eeEstados?.[0]?.Returnid || null,
                message: data?.eeEstados?.[0]?.Estado || 'Código inválido',
                timestamp: Date.now(),
                type: 'error',
              };

              reject(notification);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  getters: {
    status(state) {
      return state.status;
    },
  },
};
